<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="card-title">Lista de Contract Cover</h3>
            <div class="d-flex">
                <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#contractCoverModal"
                    @click="coverPageStore.openModal">
                    Generar
                </PrimaryButton>
            </div>
        </div>

        <div class="d-flex mt-3 mb-3">
            <input type="text" class="form-control" placeholder="Buscar Carátula..."
                v-model="coverPageStore.searchString" />
        </div>

        <div>
            <CoverPageTable :coverPages="coverPageStore.paginatedS" @sort="coverPageStore.sortBy($event)"
                @edit="coverPageStore.editData($event)" />
            <Pagination v-if="coverPageStore.filteredS.length > coverPageStore.itemsPerPage"
                :list="coverPageStore.filteredS" :items-per-page="coverPageStore.itemsPerPage"
                :current-page="coverPageStore.currentPage" @current-page="coverPageStore.setCurrentPage($event)" />
        </div>

        <Modal modal-id="contractCoverModal" :customClass="'modal-xl'">
            <div class="modal-header">
                <h4 class="modal-title">Carátula</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="coverPageStore.closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="col-12 col-md-3 col-lg-3 content-col">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
                            </div>

                            <div class="col-12 col-md-4 col-lg-4" v-show="!coverPageStore.isEdit">
                                <select id="applicationSelectCC" v-model="coverPageStore.selectedApplication"
                                    class="form-select selectpicker border-dark" data-width="100%"
                                    data-live-search="true"
                                    :disabled="!coverPageStore.loanApplicationsOptions.length && coverPageStore.loanApplicationsOptions.loanApplications !== null"
                                    title="Selecciona solicitud...">
                                    <option value="" disabled>Selecciona solicitud</option>
                                    <option v-for="application in coverPageStore.loanApplicationsOptions"
                                        :key="application.loanApplications.id" :value="application">
                                        {{ application.loanApplications.referenceNumber }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4" v-show="coverPageStore.isEdit">
                                <label for="applicationSelect" class="mb-0 font-weight-lb">
                                    {{ coverPageStore?.form?.coverPage?.referenceNumber || '' }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <ContractCover />
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="coverPageStore.closeModal">
                    {{ $getLocaleMessage('buttons', 'cancel') }}
                </button>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import { useContractCoverStore } from '@/pinia/LoanApplications/Legal/useContractCoverStore.module';
import { onMounted, nextTick, computed, watch } from "vue";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import ContractCover from '@/Components/Forms/LoanApplications/Legal/ContractCover.vue';
import CoverPageTable from '@/Components/Tables/CoverPageTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';

const coverPageStore = useContractCoverStore();
const getSelectC = () => $('#applicationSelectCC');

// Inicializa el selectpicker
const initializeSelectPicker = () => {
    nextTick(() => {
        const select = getSelectC();
        if (select.length) {
            select.selectpicker('refresh');
            if (!coverPageStore.selectedApplication) {
                select.selectpicker('val', '');
            }
        }
    });
};

// Watcher para isModalOpen
watch(
    () => coverPageStore.isModalOpen,
    (newValue) => {
        if (!newValue) {
            initializeSelectPicker();
        }
    },
);

// Watcher para las opciones del select
watch(
    () => coverPageStore.loanApplicationsOptions,
    async (newOptions) => {
        if (newOptions.length > 0 && coverPageStore.isModalOpen) {
            initializeSelectPicker();
        }
    },
    { deep: true }
);

// Watcher para actualizar nombre y fecha cuando cambia selectedApplication
watch(
    () => coverPageStore.selectedApplication,
    (newApp) => {
        if (!coverPageStore.isEdit) {
            coverPageStore.form = {};
        }

        if (newApp) {
            coverPageStore.form = newApp;
        }
    },
    { deep: true, immediate: true } // Agrega esto para que se ejecute al montar el componente immediate
);

// Cargar data al montar el componente
onMounted(async () => {
    //Cargar data de opciones de solicitud
    await coverPageStore.filterLoanApplications();
    //Cargar los datos de la tabla
    await coverPageStore.fetchCoverPage();
    //Inicializar el componente de selector
    initializeSelectPicker();
});
</script>